export const ID = 'LR47VNEYV2'
export const KEY = 'ffe86ede2e95185980646425a8d82aa2'

export const KEYWRITE = 'e91195ed70ded4c47770676f7f8f6e33'